module.exports = __webpack_public_path__ + "media/images/icons/trustpilot-star-inverted-0e38e157bbee72c275362ce3078f8bc4.svg";